import { ICreatePassword } from '../pages/createPassword/createPasswordInterface';
import { post } from './apiService';

export const createPassword = async (data: ICreatePassword) => {
  return await post('/auth/create-password', data);
};
export const resetPassword = async (data: ICreatePassword) => {
  return await post('/auth/reset-password', data);
};
